/**
 * 冷启动「先首页、再跳会话」的主线程一半（21ak）。
 *
 * 背景（人工报「从 web push 点进会话，返回是空白的」）：应用被杀死时点通知走的是
 * SW 的 `clients.openWindow(...)`。此前它开的是深链 `/chat/dm/101`——`stackForPath`
 * 虽然会把它垫成 `[首页, 会话页]`、返回键也确实能退一级，但**会话列表组件直到
 * 「返回」那一刻才第一次挂载**，它的首屏数据链（快照回包前刻意留白，
 * ConversationList.tsx `rows === null`）这时才开始跑，用户看到的就是一片空白。
 *
 * 现在 SW 改开 `/?open=dm:101`（`sw/pushEvents.ts` coldStartUrlOf）：应用在**首页**
 * 起来、列表照常挂载跑完首屏，然后本模块把 query 里的目标读走，用普通的
 * `openChat` 推一层会话页。于是历史栈是真正导航出来的两层，返回就是普通出栈，
 * 落回的那个列表也早就渲染好了。
 *
 * 两条使用约定：
 * - **必须在 `appRouter().init()` 之前读**：init 会 `replaceState(routePath(home))`，
 *   而 routePath 不带 query——query 会被顺手清掉（刻意：刷新/返回不该重放这次跳转）。
 * - 读到目标就**不要再跑冷启动恢复**（restoreState 的「回到上次会话」）：
 *   用户点的是这条通知，不是上次那个会话。实现上不需要额外开关——本模块先
 *   `openChat` 把栈推到两层，`connectColdStartRestore` 的「仅根路径单层栈」门禁
 *   自然不成立，它会直接返回 no-op。顺序因此是硬要求，见 main.tsx 接线处。
 */
import { COLD_START_PARAM, isConversationKey } from '~/sw/pushEvents';

/**
 * 从 `location.search` 取冷启动目标会话键。
 * 非法/缺失一律 null（query 来自 URL，可被用户手改，必须按不可信输入校验）。
 */
export function coldStartChatKey(search: string): string | null {
  if (search === '' || search === '?') return null;
  let value: string | null;
  try {
    value = new URLSearchParams(search).get(COLD_START_PARAM);
  } catch {
    return null;
  }
  return isConversationKey(value) ? value : null;
}
